import React, { useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { ClipLoader } from 'react-spinners';
import api from '../axiosConfig';
import './ResetPassword.css';

const ResetPassword = () => {
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();

    // Extract the token from the query string
    const token = searchParams.get('token');

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);

        try {
            const response = await api.post('/reset-password', {
                token,
                newPassword,
                confirmPassword,
            });

            if (response.status === 200) {
                toast.success(response.data.message);
                navigate('/login'); // Redirect to login page
            }
        } catch (error) {
            console.error('Error resetting password:', error);
            const errorMessage = error.response?.data?.error || 'An error occurred. Please try again.';
            toast.error(errorMessage);
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="reset-password-container">
            <h2>Reset Password</h2>
            <form onSubmit={handleSubmit} className="reset-password-form">
                <div className="input-container">
                    <input
                        type="password"
                        placeholder="New Password"
                        value={newPassword}
                        onChange={(e) => setNewPassword(e.target.value)}
                        required
                    />
                </div>
                <div className="input-container">
                    <input
                        type="password"
                        placeholder="Confirm Password"
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                        required
                    />
                </div>
                <button type="submit" className="btn-primary" disabled={isSubmitting}>
                    {isSubmitting ? <ClipLoader size={20} color="#ffffff" /> : 'Reset Password'}
                </button>
            </form>
        </div>
    );
};

export default ResetPassword;
